<div class="container mt-4">

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>

  <div class="row mb-4">

    <div class="col-md-6">
      <h5>Encuestas</h5>

      <input type="text" class="form-control mb-3" placeholder="Buscar encuestas..." [(ngModel)]="searchSurvey" (ngModelChange)="filterSurveys()">

      <div *ngIf="isLoadingSurveys" class="text-center mb-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando encuestas...</span>
        </div>
      </div>

      <div *ngIf="!isLoadingSurveys && filteredSurveys.length === 0" class="alert alert-info">
        No se encontraron encuestas.
      </div>

      <div class="scrollable-list">
        <ul class="list-group">
          <li *ngFor="let survey of filteredSurveys"
              class="list-group-item d-flex justify-content-between align-items-center"
              [ngClass]="{'selected-survey': survey === selectedSurvey}"
              (click)="selectSurvey(survey)">
            {{ survey.title }}
            <span class="badge"
                  [ngClass]="{
                    'bg-success text-light': survey.idstatus === 1,
                    'bg-secondary text-light': survey.idstatus === 2,
                    'bg-warning text-dark': survey.idstatus === 3,
                    'bg-info text-light': survey.idstatus === 4
                  }">
              {{ getSurveyStatusText(survey.idstatus) }}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-6">
      <h5>Personas que respondieron</h5>

      <input type="text" class="form-control mb-3" placeholder="Buscar personas..." [(ngModel)]="searchPerson" (ngModelChange)="filterPersons()">

      <div class="chips-container mb-4">
        <span class="chip" [ngClass]="{'chip-selected': personStatusFilter === 'all'}" (click)="setPersonFilter('all')">
            Todas ({{ totalCount }})
        </span>
        <span class="chip" [ngClass]="{'chip-selected': personStatusFilter === 'finished'}" (click)="setPersonFilter('finished')">
            Completadas ({{ finishedCount }})
        </span>
        <span class="chip" [ngClass]="{'chip-selected': personStatusFilter === 'started'}" (click)="setPersonFilter('started')">
            Iniciadas ({{ startedCount }})
        </span>
    </div>

      <div *ngIf="isLoadingPersons" class="text-center mb-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando personas...</span>
        </div>
      </div>

      <div *ngIf="!isLoadingPersons && filteredPersons.length === 0" class="alert alert-info">
        No se encontraron personas que hayan respondido.
      </div>

      <div class="scrollable-list">
        <ul class="list-group">
          <li *ngFor="let person of filteredPersons"
              class="list-group-item d-flex justify-content-between align-items-center"
              [ngClass]="{'selected-person': isPersonSelected(person)}"
              (click)="togglePersonSelection(person)">
            <span>{{ person.email }}</span>
            <span class="badge"
                  [ngClass]="{
                    'bg-success text-light': person.status === 'finished',
                    'bg-warning text-dark': person.status === 'started'
                  }">
              {{ getPersonStatusText(person.status) }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="filter-container mb-3">
    <label for="sectionFilter" class="form-label">Filtrar por Sección:</label>
    <select id="sectionFilter" class="form-select" [(ngModel)]="selectedSection" (change)="filterAnswersBySection()">
      <option value="all">Todas las Secciones</option>
      <option *ngFor="let section of uniqueSections" [value]="section">{{ section }}</option>
    </select>
  </div>

  <button *ngIf="filteredAnswers.length > 0"
    (click)="downloadCSV()"
    class="btn btn-success mb-3">
    <i class="fa fa-download"></i> Descargar respuestas
  </button>

<div class="row">
  <div class="col-md-12">
    <h5 *ngIf="selectedPerson">Respuestas de {{ selectedPerson?.email }}</h5>

    <div *ngIf="isLoadingAnswers" class="text-center mb-4">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Cargando respuestas...</span>
      </div>
    </div>

    <table class="table table-hover table-striped" *ngIf="paginatedAnswers.length > 0">
      <thead class="table-dark">
        <tr class="">
          <th scope="col">#</th>
          <th scope="col">Correo Electrónico</th>
          <th scope="col">Sección</th>
          <th scope="col">Pregunta</th>
          <th scope="col">Eje</th>
          <th scope="col">Respuesta</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let answer of paginatedAnswers; let i = index">
          <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
          <td>{{ answer.personEmail }}</td>
          <td><strong>{{ answer.section || 'Sin sección' }}</strong></td>
          <td><em>{{ answer.question || 'Pregunta desconocida' }}</em></td>
          <td>{{ answer.axis || 'N/A' }}</td>
          <td>{{ answer.answer || 'Sin respuesta' }}</td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!isLoadingAnswers && paginatedAnswers.length === 0" class="alert alert-info">
      No hay respuestas disponibles para esta persona.
    </div>

    <nav *ngIf="totalPages.length > 1" aria-label="Paginación de respuestas">
      <ul class="pagination justify-content-center">
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
          <a class="page-link" href="javascript:void(0)">Anterior</a>
        </li>
        <li class="page-item" *ngFor="let page of totalPages" (click)="changePage(page)" [class.active]="page === currentPage">
          <a class="page-link" href="javascript:void(0)">{{ page }}</a>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages.length" (click)="changePage(currentPage + 1)">
          <a class="page-link" href="javascript:void(0)">Siguiente</a>
        </li>
      </ul>
    </nav>
  </div>
</div>

</div>
